import Search from 'src/components/Search';
import { variables } from 'src/Tenants';
import React from 'react';

const SuitesSearchBar = ({ onSearch, children }: any) => (
  <div className="searchbar serviceRequestsSearch">
    <Search
      size="small"
      placeholder={'Search ' + variables.suiteName + '...'}
      onChange={onSearch}
      theme={undefined}
    />
    {children}
  </div>
);

export default SuitesSearchBar;
